import seapointLogo from '../../assets/images/logo-seapoint-name.svg';

export const SeapointLogo = () => {
  return (
    <div className="h-8 w-max">
      <img src={seapointLogo} alt="" loading="eager" fetchPriority="high" className="h-full w-full object-contain" />
    </div>
  );
};
